export default __webpack_public_path__ + "static/media/bannersweb_checoleyenda_amazon_330x330(2).f40362ba.jpg";